import React, { useContext, useState } from "react";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import CustomModal from "../../components/Modal";
import { AUTH_URL } from "../../common/common";
import { validationSchema } from "../../service/validation/verifiedDriverKYC";
import { ApiService } from "../../service/api.service";

const VerifiedDriverKYC = () => {
  const apiService = new ApiService();
  const { setToken, token } = useContext(TokenContext)!;
  const [isModalOpen, setModalOpen] = useState(false);
  const businessType = localStorage.getItem("businessType");
  let parsedBusinessType = businessType ? JSON.parse(businessType) : null;
  let entityId = localStorage.getItem("entity_id");
  let licence = localStorage.getItem("licence-moto") || ""
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      licence_number: licence,
      address: "",
      licence_name: ""
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const openModal = () => setModalOpen(true);



  const onSubmit = async (data: any) => {
    try {
      let newData = {
        type: "Driver",
        businessIds: parsedBusinessType,
        entityId: entityId,
        licenseAddress: JSON.stringify(data.address),
        licenseName: data.licence_name,
        licenseNumber: data.licence_number,
      };
      const response: any = await apiService.postApi(`${AUTH_URL}/business/store-route`, newData);
      if (response.status === "200") {
        // localStorage.setItem("user_data_motsop", JSON.stringify(response.body.data));
        const tokenValue = response.body.authToken;  // Simulated token
        localStorage.setItem("motosop", tokenValue); // Save token to localStorage
        localStorage.removeItem("licence-moto")
        setToken(tokenValue); // Update the context
        navigate('/dashboard')
      }
    } catch (error: any) {
      console.error("Verification Error:", error);
      alert(
        error.message || "Failed to verify Licence or Vehicle Number. Please try again."
      );
    }
  };

  //   const vehicleNumber = watch("vehicle_number", ""); // Watch for email value
  const licenceNumber = watch("licence_number", ""); // Watch for email value
  const licenceName = watch("licence_name", "");
  const address = watch("address", "");

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        {/* <div className="bg-[#D9D9D9] rounded-[21.25px] w-full h-full"></div> */}
        <div className="w-full h-full">
          <div className="md:mx-[8rem] my-[2rem] m-6">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins track-[1%]">
              Welcome aboard  👋
            </p>
            <p className="font-[400] font-poppins text-[14px] track-[1%] text-[#313957]">
              Driver KYC
            </p>
            <br />
            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <AuthInputText
                label="Vehicle Number"
                value={vehicleNumber}
                errors={errors}
                placeholder="Enter Vehicle Number"
                autoComplete="one-time-code"
                name="vehicle_number"
                type="text"
                // maxLength={6}
                register={register}
              /> */}
              <AuthInputText
                label="Licence Number"
                value={licenceNumber}
                errors={errors}
                placeholder="Enter Licence Number"
                autoComplete="one-time-code"
                name="licence_number"
                type="text"
                verified={true}
                toUpperCase={true}
                // maxLength={6}
                register={register}
              />
              <AuthInputText
                label="Licence Name"
                value={licenceName}
                errors={errors}
                placeholder="Enter Licence Name"
                autoComplete="one-time-code"
                name="licence_name"
                type="text"
                // maxLength={6}
                register={register}
              />
              <AuthInputText
                label="Address"
                value={address}
                errors={errors}
                placeholder="Enter Address"
                autoComplete="one-time-code"
                name="address"
                type="text"
                // maxLength={6}
                register={register}
              />

              {/* Submit button */}
              <div className="flex items-center justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-4 p-2 w-[245px] h-[40px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white rounded"
                >
                  {isSubmitting ? "Continuing..." : "Continue"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </AuthContainer>
  );
};

export default VerifiedDriverKYC;
